<template>
  <div>
    <title>商品列表</title>
    <section class="goodsBox">
        <!--S 检索-->
        <el-form :model="searchGLForm" inline class="searchForm">
            <el-form-item label="下单时间">
                <!-- S 双日期选择器 -->
                <TwoDatePicker
                    @twoDateObtain="outDateReceive"
                    :startvaldate="searchGLForm.outTime.length>0?searchGLForm.outTime[0]:''"
                    :endvaldate="searchGLForm.outTime.length>0?searchGLForm.outTime[1]:''"
                    key="out">
                </TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item label="期望发货日期动态">
                <!-- S 双日期选择器 -->
                <TwoDatePicker
                    @twoDateObtain="expectDateReceive"
                    :startvaldate="searchGLForm.expectTime.length>0?searchGLForm.expectTime[0]:''"
                    :endvaldate="searchGLForm.expectTime.length>0?searchGLForm.expectTime[1]:''"
                    key="expectTime">
                </TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item label="派单时间">
                <!-- S 双日期选择器 -->
                <TwoDatePicker
                    @twoDateObtain="termDateReceive"
                    :startvaldate="searchGLForm.paiTime.length>0?searchGLForm.paiTime[0]:''"
                    :endvaldate="searchGLForm.paiTime.length>0?searchGLForm.paiTime[1]:''"
                    key="term">
                </TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="querySubmit">查询</el-button>
                <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
                <em class="simpleSearch" style="cursor: pointer;" @click="highShow = !highShow">{{highShow?'精简筛选':'高级筛选'}}</em>
            </el-form-item>
            <div class="none" :class="{'block':highShow}">
                <el-form-item label="发货日期">
                    <!-- S 双日期选择器 -->
                    <TwoDatePicker
                        @twoDateObtain="orderDateReceive"
                        :startvaldate="searchGLForm.orderTime.length>0?searchGLForm.orderTime[0]:''"
                        :endvaldate="searchGLForm.orderTime.length>0?searchGLForm.orderTime[1]:''"
                        key="orderTime">
                    </TwoDatePicker>
                    <!-- E 双日期选择器 -->
                </el-form-item>
                <el-form-item label="订单号" class="codeSerIpt">
                    <el-input v-model="searchGLForm.orderno" placeholder="请输入订单号" clearable maxlength="30"></el-input>
                </el-form-item>
                <el-form-item label="是否为母单">
                    <el-select v-model="searchGLForm.porderno" placeholder="请选择" clearable>
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <!-- S 订单状态 -->
                <OrderState :isOstate="searchGLForm.ordstate" @orderStatusObtain="orderStatusObtain" :type="1"></OrderState>
                <!-- E 订单状态 -->
                <el-form-item label="订单类型">
                    <StaOrderType :isOdType="searchGLForm.ordertype" @orderTypeObtain="orderTypeObtain"></StaOrderType>
                </el-form-item>
                <!-- S 商品类型 -->
                <GoodsType :isGoodsType="searchGLForm.goodstype" @goodsTypeObtain="goodsTypeObtain"></GoodsType>
                <!-- E 商品类型 -->
                <el-form-item label="订单来源">
                    <OrderSource :isOrderSource="searchGLForm.prosource" @orderSourceObtain="orderSourceObtain"></OrderSource>
                </el-form-item>
                <!-- S 终端类型 -->
                <TerminalType :isTerminal="searchGLForm.terminaltype" @terminalTypeObtain="terminalTypeObtain"></TerminalType>
                <!-- E 终端类型 -->
                <el-form-item label="渠道名称">
                    <el-select v-model="searchGLForm.channelname" popper-class="scrollSelect" filterable clearable placeholder="请选择或输入" :filter-method="filterChannel" @focus="closeChannelName">
                      <div class="optionBox">
                        <el-option
                            v-for="item in channelList"
                            :key="item.channelname"
                            :label="item.channelname"
                            :value="item.channelname">
                        </el-option>
                      </div>
                      <el-pagination
                          @current-change="channelCurrentChange"
                          :current-page="channelCurrent"
                          :page-sizes="[30]"
                          :page-size="30"
                          layout="pager"
                          :total="channelBean.totalnum" v-show="channelBean.totalnum"
                          small>
                      </el-pagination>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单内容">
                    <el-input v-model="searchGLForm.ordercontent" placeholder="请输入内容" clearable></el-input>
                </el-form-item>
                <el-form-item label="省/市">
                    <el-input v-model="searchGLForm.provinceorcity" placeholder="请输入省/市" clearable></el-input>
                </el-form-item>
            </div>
        </el-form>
        <!--E 检索-->
        <!-- 注意：有合并表头样式的table，这里要加类名borderIndiv -->
        <div class="gsListTable individualiz borderIndiv">
            <el-form :model="searchGLForm" inline size="medium">
                <el-form-item class="borderline">
                    <em class="greyColor shStyle" >送货方式</em>
                    <el-checkbox-group v-model="searchGLForm.delimode" class="boxRight" @change="delimodeUpdate">
                        <el-checkbox :label="0">自提</el-checkbox>
                        <el-checkbox :label="1">送货</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain @click="specMange = true" v-show="!exportShow">任务列表</el-button>
                    <el-button type="primary" plain @click="groupShow = true" v-show="!exportShow">归类统计</el-button>
                    <el-button type="primary" plain v-show="!exportShow" @click="openExport">导出</el-button>
                    <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(0)">检索导出</el-button>
                    <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(1)">勾选导出</el-button>
                    <el-button type="danger" v-show="exportShow" icon="el-icon-close" round @click="closeExport">取消</el-button>
                </el-form-item>
            </el-form>
            <!--S 列表-->
            <!-- 注意：有合并表头样式的table要加类名borderTable -->
            <el-table ref="gsTable" class="gsTable comTable borderTable" border :data="OrderStatisticsList" :maxHeight="tableHeight" @selection-change="handleSelectionChange" v-loading="loading">
                <el-table-column v-if="exportShow" type="selection" width="100"></el-table-column>
                <el-table-column type="index" label="序号" width="80" fixed="left"></el-table-column>
                <el-table-column label="订单号" min-width="230">
                    <template slot-scope="scope">
                        <p :title="scope.row.orderno">{{scope.row.orderno}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="是否为母单" min-width="230">
                    <template slot-scope="scope">
                        <p :title="scope.row.porderno">{{scope.row.porderno}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="订单类型" min-width="120">
                    <template slot-scope="scope">
                        <p>{{scope.row.ordertypeName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="订单状态" min-width="120">
                    <template slot-scope="scope">
                        <span :class="[{'greenColor':scope.row.ordstateName=='已发货' || scope.row.ordstateName=='配货中' || scope.row.ordstateName=='部分发货'},{'orangeColor':scope.row.ordstateName=='待处理' || scope.row.ordstateName=='待付款' || scope.row.ordstateName=='订单取消待审核'},{'greyColor':scope.row.ordstateName=='订单取消' },{'redColor':scope.row.ordstateName=='问题结单'||scope.row.ordstateName=='已退款'},{'blueColor': scope.row.ordstateName=='正常结单'},]">{{scope.row.ordstateName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="券卡编码" min-width="210">
                    <template slot-scope="scope">
                      <p v-if="isMultiCardCode(scope.row.cardCodeDisplay)" class="cardCodeMulti">{{ cardCodeFilter(scope.row.cardCodeDisplay) }}</p>
                      <template v-else>
                        <p>{{scope.row.cardcode | empty}}</p>
                        <p v-if="scope.row.cardserial">【{{scope.row.cardserial}}】</p>
                      </template>
                    </template>
                </el-table-column>
                <el-table-column label="商品类型" min-width="120">
                    <template slot-scope="scope">
                        <span :class="{
                            'orangeColor':scope.row.goodstypeName == '电子券卡',
                            'blueColor': scope.row.goodstypeName=='实物'||scope.row.goodstypeName=='实体券卡'
                        }">{{scope.row.goodstypeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单来源" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.prosourceName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="终端类型" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.terminaltypeName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="送货方式" min-width="120">
                    <template slot-scope="scope">
                        <span :class="scope.row.delimodeName=='送货'?'blueColor':'orangeColor'">{{scope.row.delimodeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="下单时间" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.submitdate | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="渠道名称" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.channelname?scope.row.channelname:'--'}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="下单人" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.orderuname">{{scope.row.orderuname}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="订单内容" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.ordercontent">{{scope.row.ordercontent | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="发货日期" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.deliverdate | empty}}</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="成品价总金额（￥）" min-width="170" v-if="ElementControls('showGoodsFinishPrice')==1">
                    <template slot-scope="scope">{{scope.row.goodsfinishprice_total | empty}}</template>
                </el-table-column> -->
                <el-table-column label="商品总金额（￥）" min-width="170">
                    <template slot-scope="scope">{{scope.row.oallamount | empty}}</template>
                </el-table-column>
                <el-table-column label="收货信息" align="center">
                    <el-table-column label="收货人" min-width="150">
                        <template slot-scope="scope">
                            <p class="textHiden" :title="scope.row.receivername">{{scope.row.receivername | empty}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="联系方式" min-width="120">
                        <template slot-scope="scope">
                            <p class="textHiden">{{scope.row.receivertel | empty}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="备用联系方式" min-width="120">
                        <template slot-scope="scope">
                            <p class="textHiden">{{scope.row.othtel | empty}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="持卡人联系方式" min-width="150">
                        <template slot-scope="scope">
                            <p class="textHiden">{{scope.row.cardholdertel | empty}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="收货地址" min-width="300">
                        <template slot-scope="scope">
                            <p class="textHiden" :title="scope.row.fulladdr">{{scope.row.fulladdr | empty}}</p>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="买家备注" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.buyermemo">{{scope.row.buyermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="卖家备注" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sellermemo">{{scope.row.sellermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="订单备注" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.ordermemo">{{scope.row.ordermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="发货日期" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.recvdate | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="结单日期" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.enddate | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="结单备注" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.endmemo">{{scope.row.endmemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="订单归属" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.operpowerName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="订单归属方" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.handlercodeName">{{scope.row.handlercodeName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="派单信息" align="center">
                    <el-table-column label="派单状态" min-width="120">
                        <template slot-scope="scope">
                            <span :class="[{'orangeColor':scope.row.desstateName=='未派单'},{'greenColor':scope.row.desstateName=='派单中'},{'blueColor':scope.row.desstateName=='派单完成'},{'redColor':scope.row.desstateName=='派单退回'},{'greyColor':scope.row.desstateName=='派单取消'},]">{{scope.row.desstateName?scope.row.desstateName:'--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="派单时间" min-width="120">
                        <template slot-scope="scope">
                            <p class="textHiden">{{scope.row.desdate | empty}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="派单人" min-width="150">
                        <template slot-scope="scope">
                            <p class="textHiden" :title="scope.row.desuname">{{scope.row.desuname | empty}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="受派方" min-width="150">
                        <template slot-scope="scope">
                            <p class="textHiden" :title="scope.row.recuname">{{scope.row.recuname | empty}}</p>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="参与促销活动" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.ptypeName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="积分领取状态" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.igetstateName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="反馈积分" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.inum | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="互动游戏活动状态" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.interactivitystateName | empty}}</p>
                    </template>
                </el-table-column>
                <template slot="empty">
                  <div class="noData"><span>暂无数据</span></div>
                </template>
            </el-table>
            <!--E 商品列表-->
        </div>
        <!-- S 分页 -->
        <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
        <!-- S 分页 -->
    </section>
    <!-- S 任务列表弹窗 -->
    <TaskList :isStatistics="1" :specMange="specMange" :eleType="3" @closeTask="closeTask"></TaskList>
    <!-- E 任务列表弹窗 -->
    <!--S 归类统计-->
    <el-dialog :visible.sync="groupShow" class="comDlog seniorMdg" append-to-body :close-on-click-modal="false">
        <div slot="title" class="dialog-title">归类统计</div>
        <el-form :model="groupForm" label-width="100px">
            <el-form-item label="归类依据">
                <el-select v-model="groupForm.group" filterable placeholder="请选择或输入" clearable>
                    <el-option
                      v-for="(item,index) in groupList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                      :title="item.label">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="openGroup(1)">确定</el-button>
            <el-button @click="openGroup(0)">取消</el-button>
        </div>
    </el-dialog>
    <!--E 归类统计-->
    <!-- S 归类统计列表 -->
    <OrderClassifyStatistics :classifyValue="groupForm.group" :queryParams="queryParams" :groupDetailShow="groupDetailShow" @closePop="closeCstatis"></OrderClassifyStatistics>
    <!-- E 归类统计列表 -->
  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
    name:'OrderStatisticsDetail',
    data () {
        return {
            highShow: false, //是否展示高级筛选
            groupShow: false,//归类统计弹窗
            searchGLForm:{
                outTime: [], // 出库时间段
                paiTime: [], // 派单时间段
                expectTime: [], // 期望发货时间段
                startSerial: '', // 开始序列号
                endSerial: '', // 结束序列号
                orderno: '', // 券卡编码
                porderno: '', // 是否为母单
                ordstate: [], // 订单状态
                ordertype: '', //订单类型
                goodstype: '', // 商品类型
                prosource: '', // 订单来源
                terminaltype: '', // 终端类型
                delimode: [], // 送货方式
                channelname: '', // 销售渠道
                orderTime: [], // 发货时间段
                ordercontent: '', // 订单内容
                provinceorcity: '', // 检索的省市名称
            },
            tableHeight: window.innerHeight*.8, //表格动态高度
            specMange:false, //任务列表弹窗
            groupForm:{
                group:''
            },//归类统计弹窗
            groupList:[
                { value: "ordstate", label: "订单状态" },
                { value: "goodstype", label: "商品类型" },
                { value: "prosource", label: "订单来源" },
                { value: "terminaltype", label: "终端类型" },
                { value: "delimode", label: "送货方式" },
            ],//归类统计
            pageSize: 30, // 每页展示的条数
            currentPage: 1, // 当前请求的页数
            pagebBean: {
                totalnum: 0,
            }, // 获取到的列表分页信息
            OrderStatisticsList: [], // 订单统计详情列表
            exportShow: false, // 是否为导出操作
            multipleSelection: [], // 选中的列表数据
            printingShow: true, // 防止多次点击导出按钮
            groupDetailShow:false,//归类统计详情弹窗显隐
            queryParams: '', // 归类列表查询参数
            objtype: 0, // 统计入口
            loading: false, // 加载中弹窗显示和隐藏
            channelList: [], // 获取的销售渠道列表
            queryChannelname: '', // 检索的流向名称
            channelCurrent: 1, // 请求的商品的页面
            channelBean: { // 返回的商品分页信息
                totalnum: 0,
            },
        }
    },
    filters: {
    },
    components: {
        Page: resolve => require(["@/components/common/Page.vue"], resolve),
        TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
        TaskList: resolve =>require(["@/components/StatisticsFolder/TaskList.vue"], resolve), // 任务列表组件
        OrderClassifyStatistics: resolve =>require(["@/components/StatisticsFolder/OrderClassifyStatistics.vue"], resolve), // 订单归类统计列表组件
        OrderState: resolve =>require(["@/components/Gadget/OrderState.vue"], resolve), // 订单状态下拉组件
        StaOrderType: resolve =>require(["@/components/Gadget/StaOrderType.vue"], resolve), // 订单类型下拉组件
        GoodsType: resolve =>require(["@/components/Gadget/GoodsType.vue"], resolve), // 商品类型下拉组件
        OrderSource: resolve =>require(["@/components/Gadget/OrderSource.vue"], resolve), // 订单来源下拉组件
        TerminalType: resolve =>require(["@/components/Gadget/TerminalType.vue"], resolve), // 终端类型下拉组件
    },
    // ============================================== 监听 ==============================================
    watch: {
        
    },
    // ============================================== 方法 ==============================================
    methods: {
        // 是否多券卡编码（兼容真换行与字面量 \n）
        isMultiCardCode(val) {
            if (!val) return false;
            const str = String(val);
            return str.includes('\n') || str.includes('\\n');
        },
        // 多券卡编码展示：把字面量 \n 转成真换行，配合 CSS pre-line 换行（不用 v-html）
        cardCodeFilter(val) {
            if (!val) return '';
            return String(val).replace(/\\n/g, '\n');
        },
        // 接收选中的发货日期
        orderDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.orderTime[0] = info[0];
                this.searchGLForm.orderTime[1] = info[1];
            } else {
                this.searchGLForm.orderTime = [];
            }
        },
        // 获取销售渠道列表
        getChannelList(size) {
            let params = {
                keyword: this.queryChannelname,
                pageparam: {
                    pagesize: size?size:30, //每页条数
                    currentpage: this.channelCurrent, //当前页数
                    isnewcomp: 1 //是否需要重新统计页数
                }
            };
            api.GET_CHANNELNAMELIST(params).then(res => {
                if(res.data.status == "200") {
                    if(res.data.data&&res.data.data.length>0) {
                        this.channelList = res.data.data;
                    } else{
                        this.channelList = [];
                    }
                    this.channelBean = res.data.pagebean;
                }
            })
        },
        // 渠道分页
        channelCurrentChange(val) {
            this.channelCurrent = val;
            this.getChannelList();
        },
        // 搜索渠道方法
        filterChannel(item) {
            this.queryChannelname = item;
            this.channelCurrent = 1;
            this.getChannelList();
        },
        // 清除筛选的名称
        closeChannelName() {
            this.queryChannelname = '';
            this.channelCurrent = 1;
            this.getChannelList();
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
            this.tableHeight = window.innerHeight - tbHeight - 130; 
        },
        // 接收选中的出库日期
        outDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.outTime[0] = info[0];
                this.searchGLForm.outTime[1] = info[1];
            } else {
                this.searchGLForm.outTime = [];
            }
        },
        // 接收选中的有效期日期
        termDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.paiTime[0] = info[0];
                this.searchGLForm.paiTime[1] = info[1];
            } else {
                this.searchGLForm.paiTime = [];
            }
        },
        // 接收选中的期望发货日期
        expectDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.expectTime[0] = info[0];
                this.searchGLForm.expectTime[1] = info[1];
            } else {
                this.searchGLForm.expectTime = [];
            }
        },
        // 检索的送货方式
        delimodeUpdate(val) {
            if(val.length>1) {
                val.splice(0,1)
            }
            this.querySubmit()
        },
        // 返回请求参数
        returnQueryInfo() {
            let detailParams = {
                startdate: this.searchGLForm.outTime.length>0?this.dateTime(this.searchGLForm.outTime[0]):'',
                enddate: this.searchGLForm.outTime.length>0?this.dateTime(this.searchGLForm.outTime[1]):'',
                startdesdate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[0]):'',
                enddesdate: this.searchGLForm.paiTime.length>0?this.dateTime(this.searchGLForm.paiTime[1]):'',
                startrecvdate: this.searchGLForm.expectTime.length>0?this.dateTime(this.searchGLForm.expectTime[0]):'',
                endrecvdate: this.searchGLForm.expectTime.length>0?this.dateTime(this.searchGLForm.expectTime[1]):'',
                orderno: this.searchGLForm.orderno,
                porderno: this.searchGLForm.porderno,
                ordertype: this.searchGLForm.ordertype,
                ordstate: this.searchGLForm.ordstate,
                goodstype: this.searchGLForm.goodstype,
                prosource: this.searchGLForm.prosource,
                terminaltype: this.searchGLForm.terminaltype,
                delimode: this.searchGLForm.delimode.length>0?this.searchGLForm.delimode[0]:'',
                channelname: this.searchGLForm.channelname, // 销售渠道
                delstartdate: this.searchGLForm.orderTime.length>0?this.dateTime(this.searchGLForm.orderTime[0]):'',
                delenddate: this.searchGLForm.orderTime.length>0?this.dateTime(this.searchGLForm.orderTime[1]):'',
                ordercontent: this.searchGLForm.ordercontent, // 订单内容
                provinceorcity: this.searchGLForm.provinceorcity, // 检索的省市名称
            };
            return detailParams;
        },
        // 获取券卡统计详情列表
        getOrderstatisticsDetail() {
            this.loading = true;
            let detailParams = this.returnQueryInfo();
            detailParams.pageparam = {
                pagesize: this.pageSize, //每页条数
                currentpage: this.currentPage, //当前页数
                isnewcomp: 1 //是否需要重新统计页数
            }
            api.GET_ORDERSTATISTICSDETAIL(detailParams).then(res => {
                this.loading = false;
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data !='null') {
                        this.OrderStatisticsList = res.data.data;
                    } else {
                        this.OrderStatisticsList = [];
                    }
                    this.pagebBean = res.data.pagebean;
                }
            }).catch(res => {
                this.loading = false;
            })
        },
        // 接收分页信息
        updatePage(size,num) {
            this.pageSize = size;
            this.currentPage = num;
            this.getOrderstatisticsDetail();
        },
        // 检索确定事件
        querySubmit() {
            this.currentPage = 1;
            this.getOrderstatisticsDetail();
        },
        // 打开归类选择弹窗
        openGroup(type) {
            if(type == 1) {
                if(!this.groupForm.group) {
                    this.$message({
                        type: 'warning',
                        message: '请选择归类依据！'
                    })
                    return false;
                }
                // 获取归类统计列表
                this.queryParams = this.returnQueryInfo();
                this.groupDetailShow = true;
            } else {
                this.groupForm.group = '';
                this.groupShow = false;
            }
        },
        // 导出操作显示
        openExport() {
            this.exportShow = true;
        },
        // 取消导出
        closeExport() {
            this.multipleSelection = [];
            this.$refs.gsTable.clearSelection(); // 清空选中列表数据
            this.exportShow = false;
        },
        // 打印操作确认事件
        toPrinting(type) {
            if(this.printingShow) {
                let queryParams = this.returnQueryInfo();
                queryParams.objtype = this.objtype;
                if(type == 1) {
                    if(this.multipleSelection&&this.multipleSelection.length>0) {
                        queryParams.exceltype = 1;
                        let alltotales = '';
                        this.multipleSelection.forEach(item => {
                            if(alltotales!=='') {
                                alltotales = alltotales + ',' + item.orderno;
                            } else {
                                alltotales = item.orderno;
                            }
                        })
                        this.loading = true;
                        this.printingShow = false;
                        queryParams.alltotale = alltotales;
                        this.getUrlForOrderstatisticsDetail(queryParams);
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '请至少勾选一项！'
                        })
                    }
                } else {
                    this.loading = true;
                    this.printingShow = false;
                    queryParams.exceltype = 0;
                    this.getUrlForOrderstatisticsDetail(queryParams);
                }
            }
        },
        // 获取兑换礼券统计详细列表信息下载地址
        getUrlForOrderstatisticsDetail(params) {
            api.GET_URLFORORDERSTATISTICSDETAIL(params).then(res => {
                this.printingShow = true;
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data.indexOf('http')!=-1) {
                        window.location.href = res.data.data;
                        this.$message({
                            type: 'success',
                            message: res.data.message
                        })
                        this.closeExport();
                    } else {
                        MessageBox.confirm(`${res.data.data}`, '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'success'
                        }).then(() => {
                            this.closeExport();
                        }).catch(() => {})
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
                this.loading = false;
            }).catch(res => {
                this.printingShow = true;
                this.loading = false;
            })
        },
        //表格多选选中行复制
        handleSelectionChange(val) { 
            this.multipleSelection = val;
        },
        // 关闭任务列表弹窗
        closeTask() {
            this.specMange = false;
        },
        // 关闭归类统计列表
        closeCstatis() {
            this.groupForm.group = '';
            this.groupShow = false;
            this.groupDetailShow = false;
        },
        // 接收选中的订单状态
        orderStatusObtain(val) {
            this.searchGLForm.ordstate = val;
        },
        // 接收选中的订单类型
        orderTypeObtain(val) {
            this.searchGLForm.ordertype = val;
        },
        // 接收选中的商品类型
        goodsTypeObtain(val) {
            this.searchGLForm.goodstype = val;
        },
        // 接收选中的订单来源
        orderSourceObtain(val) {
            this.searchGLForm.prosource = val;
        },
        // 接收选中的终端类型
        terminalTypeObtain(val) {
            this.searchGLForm.terminaltype = val;
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
        let startDate = new Date();
        let endDate = new Date();
        startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 365);
        if(sessionStorage.getItem('ticsQueryInfo')&&sessionStorage.getItem('ticsQueryInfo')!=undefined) {
            let ticsQueryInfo = JSON.parse(sessionStorage.getItem('ticsQueryInfo'));
            setTimeout(() => {
                if(ticsQueryInfo.eleType&&ticsQueryInfo.eleType!='0') {
                    if(ticsQueryInfo.eleType!='delimode') {
                        this.searchGLForm[ticsQueryInfo.eleType] = ticsQueryInfo.value;
                    } else {
                       this.searchGLForm.delimode.push(ticsQueryInfo.value);
                    }
                }
                this.searchGLForm.outTime = ticsQueryInfo.paiTime!=undefined?(ticsQueryInfo.paiTime.length>0?ticsQueryInfo.paiTime:[startDate,endDate]):[startDate,endDate];
            }, 305);
        };
        setTimeout(() => {
            this.getOrderstatisticsDetail();
        }, 310);
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)
        if(this.$route.query.objtype) {
            this.objtype = Number(this.$route.query.objtype);
        }
    },
    computed: {},
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
@import '../../GoodsFolder/Css/style.css';
.goodsBox {padding:20px; height:calc(100% - 40px);}
.gsTable em{
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    width: 20px;
    color:
    #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-left: 10px;
}
.gsTable .orange{background-color: #FF7018;}
.gsTable .blue{background-color: var(--main-color);}
.gsTable .iconhand::before {
    font-size: 20px;
    padding-right: 5px;
    display: inline-block;
    vertical-align: top;
}
.gsTable >>> .el-table__header .el-form-item {margin-bottom:0!important;}
.goodsUse {position:relative;height:36px;padding-right:15px;border-right:solid 1px #dcdfe6;}
.goodsUse em {position:absolute; left:0; top:-20px; font-size: 12px; color:#999;}
.gsTable.el-table >>> thead.is-group > tr:first-child th .cell{overflow: visible!important;}
.gsTable.el-table >>> thead.is-group > tr:nth-child(2) th .cell {color:#333;}
.gsTable.el-table >>> .el-table__body .el-checkbox {padding:20px;}
.gsTable.el-table >>> .el-table__header .el-checkbox {padding:0 20px;}
.gsTable >>> .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.inlineMember {padding:0 10px; border:solid 1px #dcdfe6; height:38px; line-height:38px;}
.childView.takeLeft .inlineMember,.childView.helpRight .inlineMember {margin-top:0px;}
@media only screen and (max-width: 1700px) {
  .inlineMember {margin-top:10px;} 
}
.inlineMember a:first-child {position:relative; width:30px; height:30px; margin:3px 0; border-radius:50%; overflow: hidden; border:solid 1px #ebeef5; }
.inlineMember img {position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; width:30px; }
.inlineMember * {display:inline-block; vertical-align: top; font-size: 14px;}
.inlineMember span {margin-right:10px;}
.inlineMember i {color:#999;}
.inlineMember em {max-width:150px; width: auto;}
.inlineMember .iconmale {font-size: 18px;color:var(--main-color);}
.inlineMember .iconfemale {font-size: 18px;color:#f56c6c;}
.goodsImg{
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  border: solid 1px #dcdfe6;
  border-radius:100%;
  margin-right:10px;
}
.goodsImg img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: 100%;
  border-radius: 50%;
}
.goodsCont h3{font-size:14px!important;font-weight:bold;}
.goodsCont p{font-size:12px;}
.goodsCont{width: calc(100% - 65px);}
.actShow {padding-top:10px; color:#999;  font-size: 12px;}
.actShow span {display:inline-block; margin-right:35px;}
.actShow span b {font-weight: 600; padding-right:5px;}
/*归类统计弹窗*/
.seniorMdg >>> .el-dialog {width:500px;}
.seniorMdg >>> .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.seniorMdg >>> .el-form-item__content .el-select {width:100%;}
.none{display: none;}
.block{display: block;}
.cardCodeMulti {white-space: pre-line; word-break: break-all;}
.shStyle{top: 0 !important;}
.borderline .boxRight{margin-left: 4rem;}
.individualiz form{padding-top: 5px !important;}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/OrderStatistics/OrderStatisticsDetail.vue